import React from 'react';
import { observer } from 'mobx-react';

import { CheckoutStore } from '../../stores/CheckoutStore';
import { CheckoutSummary } from '../checkout-summary';

const IncrementalCheckoutSummary = (props) => {
  const {
    billingData,
    checkoutCart,
    paymentType,
    bank,
    pickupChosen,
    selectedAddress,
    selectedOption,
    selectedTimeSlot,
    selectedInstallationOptions,
  } = CheckoutStore;
  return (
    <CheckoutSummary
      {...props}
      address={selectedAddress}
      billingData={billingData}
      cart={checkoutCart}
      bank={bank}
      installationData={selectedInstallationOptions || []}
      isPickup={pickupChosen}
      paymentMethodId={paymentType ? paymentType.id : null}
      shippingOption={selectedOption}
      timeSlot={selectedTimeSlot}
    />
  );
};

const ObservedIncrementalCheckoutSummary = observer(IncrementalCheckoutSummary);

export { ObservedIncrementalCheckoutSummary as IncrementalCheckoutSummary };



// WEBPACK FOOTER //
// ./src/common/incremental-checkout-summary/IncrementalCheckoutSummary.jsx